<template>
  <!--查看大图cover-->
  <tk-cover
    :show.sync="isWatch"
    :hideOnClick="false"
    transition
    color="rgba(255, 255, 255, 0)"
    :through="false"
  >
    <!--由于下载原因 去掉开始索引:start-position="watchNum"-->
    <van-image-preview
      v-model="isWatch"
      :images="commodityImage"
      closeable
      closeIcon="cross"
      closeOnPopstate
      show-index
      :start-position="viewIndex"
      ref="viewBigImage"
      @touchstart.native="gtouchstart($event)"
      @touchmove.native="gtouchmove()"
      @touchend.native="gtouchend()"
      @change="changeView"
      className="extend-class"
    >
      <template v-slot:index>{{ viewIndex + 1 + ' / ' + commodityImage.length }}</template>
    </van-image-preview>
    <tk-flex
      middle
      center
      v-if="touchDownStatus && isWatch"
      class="view-down-load animate__animated
        animate__fadeInUp font-15"
      @click.native="downLoad"
    >
      <tk-icon :size="12" color="white" style="height: 15px;padding-top: 2px;" class="m-r-2">xiazai</tk-icon>
      保存到手机
    </tk-flex>
    <!--下载弹框-->
    <tkui-dialog closeIcon hideAction :show.sync="isDownLoadStatus" center>
      <div class="subhead">
        <tk-flex column class="p-r-24">
          <div class="font-14">{{!downError ? '下载：' + fileName : downError}}</div>
          <div class="m-t-15 font-12"> {{'下载进度：' + percent + '%'}}</div>
        </tk-flex>
        <load-progress
          class="m-t-15"
          v-if="percent"
          :percent="percent"
          :progress-show="true"
          type="rect"
          :rect-width="230"
          :rect-height="5"
          :pathColors="['#f5f5f5', '#7f7eff']"
          :text-color="'rgba(255, 255, 255, 0)'"
        ></load-progress>
      </div>
    </tkui-dialog>
  </tk-cover>
</template>

<script>
import { ImagePreview } from 'vant'
import loadProgress from '@/components/loadProgress'
import { readyToDownloadFromNet } from '@/assets/help/download'
import { getImageName, waterMarkImage } from '@/assets/help/tool'
export default {
  components: {
    [ImagePreview.Component.name]: ImagePreview.Component,
    loadProgress
  },
  props: {
    commodityImage: {
      type: Array,
      required: true
    },
    watchNum: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      isWatch: false,
      viewIndex: 0,
      touchDownStatus: false, // 长按下载状态
      timeOutEvent: 0, // 长按延时器定义
      fileName: null, // 当前下载的文件
      isDownLoadStatus: false, // 下载状态
      percent: 0, // 下载进度
      downError: null // 下载提示
    }
  },
  watch: {
    isWatch (val) {
      if (!val) {
        this.$tkStatusBar.show() // 状态栏沉浸式
        this.setStatusBar('dark')
        this.touchDownStatus = false
      }
    }
  },
  methods: {
    async showImages () {
      this.isWatch = true
      await this.$tkHelper.sleep(0)
      this.viewIndex = this.watchNum
      if (this.$refs.viewBigImage) {
        this.$refs.viewBigImage.swipeTo(this.viewIndex)
      }
      this.$tkStatusBar.hide() // 状态栏沉浸式
      this.setStatusBar('dark')
    },
    changeView (num) {
      this.viewIndex = num
      this.touchDownStatus = false
    },
    /**
     * 长按操作
     * @date: 2020/8/21
     */
    gtouchstart (e) {
      this.timeOutEvent = setTimeout(() => {
        this.touchDownStatus = true
      }, 500)
      return false
    },
    /**
     * 手释放，如果在500毫秒内就释放，则取消长按事件，此时可以执行onclick应该执行的事件
     * @date: 2020/8/21
     */
    gtouchend () {
      clearTimeout(this.timeOutEvent)// 清除定时器
      if (this.timeOutEvent !== 0) {
        // 这里写要执行的内容（尤如onclick事件）
        // alert('你这是点击，不是长按')
        // recipient 接收人 replytoe 回复人
      }
      return false
    },
    /**
     * 如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按
     * @date: 2020/8/21
     */
    gtouchmove () {
      clearTimeout(this.timeOutEvent) // 清除定时器
      this.timeOutEvent = 0
    },
    /**
     * 下载图片保存手机
     * @date: 2020/9/4
     */
    async downLoad () {
      let splitUrl = this.commodityImage[this.viewIndex]
      let url = waterMarkImage(splitUrl)
      this.fileName = getImageName(splitUrl)
      this.isDownLoadStatus = true
      let percent = new Promise(resolve => {
        readyToDownloadFromNet(url, 'image', this.fileName, {
          downloading: async (progress, text) => {
            this.percent = progress
            if (this.percent === 100) {
              await this.$tkHelper.sleep(300)
              this.isDownLoadStatus = false
              resolve(progress)
            }
          },
          errorDownload: (error) => {
            this.percent = null
            this.downError = error
            this.isDownLoadStatus = false
            resolve(-1)
          }
        })
      })
      let judgePercent = await percent
      // 修改数据库
      if (judgePercent === -1) {
        this.isDownLoadStatus = false
        return this.$tkGlobal.toast.add('下载失败')
      }
      if (judgePercent === 100) {
        this.$tkGlobal.toast.add('下载成功')
        this.touchDownStatus = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .view-down-load {
    position: absolute;
    z-index: 3000;
    bottom: 10%;
    color: #ffffff;
    overflow: hidden;
    padding: 6px 15px 7px 15px;
    width: 124px;
    white-space: nowrap;
    left: calc((100vw - 124px) / 2);
    background-color: #525252;
    border-radius: 25px;
  }
</style>
